module.exports = __webpack_public_path__ + "img/ratecards.2174a189.svg";